var map = {
	"./banner.webp": "Pq4B",
	"./bar.webp": "8dFz",
	"./nofind.webp": "CP0J",
	"./ptGame-bg-active.webp": "SG1S",
	"./ptGame-bg-default.webp": "3snc",
	"./ptGame1.webp": "x9Up",
	"./ptGame2.webp": "3qd3",
	"./ptGame3.webp": "ZcbS",
	"./ptGame4.webp": "hNnf",
	"./ptGame5.webp": "l8H5",
	"./ptGame6.webp": "O+bV",
	"./ptsearch.webp": "18E/"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "LgEV";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/ptgames ^\.\/.*\.webp$
// module id = LgEV
// module chunks = 3